import {gsap} from "gsap";

export class HeaderNavigation {

  menuToggler = document.querySelector('.js-header-navigation-dropdown-toggler')
  menuClose = document.querySelector('.js-header-navigation-dropdown-close')
  menuDropdown = document.querySelector('.header__dropdown-menu')
  menuMobileToggler = document.querySelector('.js-header__button--mobile-menu-toggler')
  menuMobile = document.querySelector('.header__mobile-nav')
  mq = window.matchMedia('(max-width:991px)')

  constructor() {

    this.menuMobileToggler.addEventListener('click', this.mobileMenuToggle.bind(this))
    this.mq.addListener(this.disableSlide.bind(this))
  }

  mobileMenuToggle(e) {
    e.preventDefault()
    this.slide(this.menuMobile)
    this.menuMobileToggler.classList.toggle('show')
    document.querySelector('body').classList.toggle('mobile-menu-opened')

  }

  isMobile() {
    return this.mq.matches
  }

  slide(elem) {
    gsap.fromTo(elem,{
      x: '100%'
    },{
      x: '0%',
      duration: 0.3,
      onComplete: () => {
        elem.classList.toggle('show', !elem.classList.contains('show'))
      },
      runBackwards: elem.classList.contains('show')
    })
  }

  disableSlide(e) {
    if (!e.matches) {
      this.menuMobile.style.transform = 'translateX(0)'
      this.menuMobile.classList.remove('show')
      this.menuMobileToggler.classList.remove('show')
    } else {
      this.menuMobile.style.transform = 'translateX(100%)'
    }

    document.querySelector('body').classList.remove('mobile-menu-opened')
  }
}

